import { getToken as c, getLocalLanguage as h, getDataCenter as y } from "../localStorage/index.mjs";
import R from "axios";
import g from "dayjs";
const x = (a = {}) => {
  const { createOptions: o = {}, noAuthPaths: r = [], excludeBaseUrlList: s = [], dev: m = !1 } = a, u = R.create({
    baseURL: "/api",
    timeout: 50 * 1e3,
    headers: {
      platform: "AK9D8H"
    },
    ...o
  });
  return u.interceptors.request.use(
    (e) => {
      if (c() && !r.includes((e == null ? void 0 : e.url) || "") && (e.headers.Authorization = c()), e.headers.language = h(), e.headers.operationDate = g(/* @__PURE__ */ new Date()).format("YYYY-MM-DD HH:mm:ss"), f(e.data || e.params, e.method), s.includes(e.url))
        e.baseURL = "";
      else {
        const n = y();
        n && !m && (e.baseURL = n + e.baseURL);
      }
      return e;
    },
    (e) => Promise.reject(e)
  ), u.interceptors.response.use(
    (e) => {
      switch (e.status) {
        case 200:
          if (e.config.responseType && e.config.responseType === "blob") {
            const t = e.data, i = e.headers["content-disposition"];
            if (i) {
              const l = window.decodeURI(i.split(";")[1].replace(new RegExp("filename="), "").replace(new RegExp('"', "g"), "")).trim();
              return { blob: t, fileName: l };
            } else
              return { blob: t };
          } else if (e.config.responseType == "arraybuffer") {
            let t = "";
            const i = e.data, l = new Uint8Array(i), p = l.byteLength;
            for (let d = 0; d < p; d++)
              t += String.fromCharCode(l[d]);
            return t;
          } else {
            if (e.config.fullData)
              return e.data;
            if (e.data && e.data.code === 200) {
              const t = e.data.data;
              return t && t.pageIndex && t.pageCount && t.pageIndex > t.pageCount && (t.total || t.total === 0) && t.total++, t;
            } else
              return Promise.reject(e.data);
          }
      }
    },
    (e) => {
      var t;
      const n = { msg: e.message, code: (t = e.response) == null ? void 0 : t.status, data: null };
      return Promise.reject(n);
    }
  ), u;
};
function f(a, o) {
  for (const r in a) {
    const s = a[r];
    typeof s == "string" && (o === "get" && (s.trim().indexOf("[") > -1 || s.trim().indexOf("]") > -1) ? a[r] = encodeURIComponent(s.trim()) : a[r] = s.trim()), typeof s == "object" && s !== null && !(s instanceof File) && f(a[r], o);
  }
}
const L = x;
export {
  L as default
};
